import { useState } from 'react';

import getUrl from './getUrl';

const TOTAL_SIZES = 2;

function createSrcSet(cdnSrc) {
  const srcSet = [];

  for (let i = 0; i < TOTAL_SIZES; i += 1) {
    const size = i + 1;
    srcSet.push(`${cdnSrc}&dpr=${size} ${size}x`);
  }

  return srcSet.join(',');
}

const ImageCdn = ({ src, alt = '', height = null, width = null, ...otherProps }) => {
  const [hasLoadingError, setLoadingError] = useState(false);

  const commonImageProps = {
    alt,
    width: width || null,
    height: height || null,
    ...otherProps,
  };

  const proxifiedUrl = getUrl(src, width, height);
  const isNonProxifiableUrl = proxifiedUrl === src;

  const imageProps =
    hasLoadingError || isNonProxifiableUrl
      ? {
          src,
        }
      : {
          src: proxifiedUrl,
          srcSet: createSrcSet(proxifiedUrl),
          onError: () => {
            setLoadingError(true);
          },
        };

  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...commonImageProps}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...imageProps}
    />
  );
};

export default ImageCdn;
